module.exports = __webpack_public_path__ + "static/media/ArrowDown.cdc83e73.svg";